const calcSchoolYear = () => {
    let _currentSchoolYear = new Date();
    let _returnValue;
    if (_currentSchoolYear.getMonth() <= 6) {
        let _value1 = _currentSchoolYear.getFullYear() - 1,
            _value2 = _currentSchoolYear.getFullYear();
        _returnValue = _value1 + ' - ' + _value2;
    } else {
        let _value1 = _currentSchoolYear.getFullYear(),
            _value2 = _currentSchoolYear.getFullYear() + 1;
        _returnValue = _value1 + ' - ' + _value2;
    }

    return _returnValue;
};

export default calcSchoolYear;
